export default {"src":"/_next/static/media/sls.61e5d681.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};